import React, { useContext } from "react";
import WizardContext from "./WizardContext";

/**
 * WizardView.Page - Component for declaring a wizard page
 *
 * Props:
 *   - title: Title of the page (shown in stepper)
 *   - icon: Font Awesome icon class (optional, default: "circle")
 *   - skippable: Whether this page can be skipped (optional, default: false)
 *   - onNextRequested: Callback when user clicks Next
 *   - onBackRequested: Callback when user clicks Back
 *   - onFinishRequested: Callback when user clicks Finish
 *   - children: The actual page content
 *
 * Event object passed to callbacks contains:
 *   - event.detail.inputManifest: The input/reference manifest object (read-only)
 *   - event.detail.emittedManifest: The emitted manifest object (read/write)
 *   - event.detail.prevented: Set to true to prevent navigation
 */
const Page = (props) => {
    const context = useContext(WizardContext);

    return (
        <div>
            {typeof props.children === "function"
                ? props.children({
                      inputManifest: context.inputManifest,
                      emittedManifest: context.emittedManifest,
                      context,
                  })
                : React.isValidElement(props.children)
                ? React.cloneElement(props.children, {
                      inputManifest: context.inputManifest,
                      emittedManifest: context.emittedManifest,
                      onNextRequested: props.onNextRequested,
                      onBackRequested: props.onBackRequested,
                      onFinishRequested: props.onFinishRequested,
                  })
                : props.children}
        </div>
    );
};

export default Page;
